import { render, staticRenderFns } from "./ReceiveParcel.vue?vue&type=template&id=135ccedf&"
import script from "./ReceiveParcel.vue?vue&type=script&lang=js&"
export * from "./ReceiveParcel.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveParcel.vue?vue&type=style&index=0&id=135ccedf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports